import { render, staticRenderFns } from "./ModalVue.vue?vue&type=template&id=27f98f0c&scoped=true&"
import script from "./ModalVue.vue?vue&type=script&lang=js&"
export * from "./ModalVue.vue?vue&type=script&lang=js&"
import style0 from "./ModalVue.vue?vue&type=style&index=0&id=27f98f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f98f0c",
  null
  
)

export default component.exports